/* eslint-disable */
import * as registry from '../registry.js'
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Zotero_Library_Item_CountInputs */

const en_zotero_library_item_count = /** @type {(inputs: Zotero_Library_Item_CountInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("en", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`1 document`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} documents`);
	return /** @type {LocalizedString} */ ("zotero_library_item_count");
};

const es_zotero_library_item_count = /** @type {(inputs: Zotero_Library_Item_CountInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("es", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`1 documento`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} documentos`);
	return /** @type {LocalizedString} */ ("zotero_library_item_count");
};

/**
* | countPlural | output |
* | --- | --- |
* | "one" | "1 document" |
* | "other" | "{count} documents" |
*
* @param {Zotero_Library_Item_CountInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const zotero_library_item_count = /** @type {((inputs: Zotero_Library_Item_CountInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Zotero_Library_Item_CountInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_zotero_library_item_count(inputs)
	return en_zotero_library_item_count(inputs)
});